import { render } from "./ListeCategorieTaxe.vue?vue&type=template&id=88539296"
import script from "./ListeCategorieTaxe.vue?vue&type=script&lang=js"
export * from "./ListeCategorieTaxe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__